import { render, staticRenderFns } from "./DestekDetayCevap.vue?vue&type=template&id=2314e0e0&scoped=true"
import script from "./DestekDetayCevap.vue?vue&type=script&lang=js"
export * from "./DestekDetayCevap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2314e0e0",
  null
  
)

export default component.exports